<template>
  <modal
    :name="name"
    :width="400"
    :height="'auto'"
    :adaptive="true"
    :click-to-close="false"
    :reset="true"
    class="modal-not-overflow"
    draggable=".popup__title"
  >
    <div class="popup">
      <button class="popup__close" type="button" @click="close"></button>
      <div class="popup__title">Reject leave request</div>
      <div class="popup__body">
        <form @submit.prevent="submit">
          <app-form-group label="Decision reason" required>
            <app-textarea
              v-model="reason"
              placeholder="Why is the request rejected?"
              :error="$v.reason.$error"
            />
            <template #error>
              <div v-if="$v.reason.$dirty && !$v.reason.present">Required field</div>
            </template>
          </app-form-group>
          <app-cells :indent="false" position="center">
            <app-button :disabled="submitting" type="submit">Reject</app-button>
          </app-cells>
        </form>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'SalesLeaveRejectModal',
  props: {
    name: {
      type: String,
      default: 'sales-leave-reject'
    },
    // (request, reason) => Promise
    rejectRequest: {
      type: Function,
      required: true
    }
  },
  data() {
    return { request: null, reason: '', submitting: false }
  },
  validations: {
    reason: {
      present(value) {
        return Boolean((value || '').trim())
      }
    }
  },
  methods: {
    open(request) {
      this.request = request
      this.reason = ''
      this.$v.$reset()
      this.$modal.show(this.name)
    },
    close() {
      this.$modal.hide(this.name)
    },
    submit() {
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.submitting = true
      this.rejectRequest(this.request, this.reason.trim())
        .then(() => {
          this.$notify({ type: 'success', title: 'Request rejected' })
          this.close()
          this.$emit('done')
        })
        .catch(() => {})
        .finally(() => { this.submitting = false })
    }
  }
}
</script>
